import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

/**
 * Fields recording who made a change, spread into task writes so the
 * server-side notification trigger can skip notifying that person.
 */
export function actorStamp() {
  try {
    const u = getAuth(getApp()).currentUser;
    return u ? { lastActorUid: u.uid, lastActorName: u.displayName || u.email || null } : {};
  } catch (_) { return {}; }
}
